import React, { memo, useContext } from 'react';
import DetailsCard from './DetailsCard';
import S from './style/CounterPartUserCard';
import { TAB_TYPE_SELLING } from '../../constants';
import TransactionContext from '../contexts/TransactionContext';
import useI18n from '../../../../i18n/hooks/useI18n';
import TabsContext from '../contexts/TabsContext';

const CounterPartUserCard: React.FC = function CounterPartUserCard() {
  const i18n = useI18n();
  const tabType = useContext(TabsContext);

  const transaction = useContext(TransactionContext);
  const counterPart = tabType === TAB_TYPE_SELLING ? transaction?.buyer : transaction?.seller;
  const noPhone = counterPart && !counterPart.phone;

  const lines = [
    { desc: 'firstname', val: counterPart?.name },
    {
      desc: 'phonenumber',
      val: noPhone ? '---' : counterPart?.phone,
      link: !noPhone,
    },
  ];

  return (
    <DetailsCard
      data-cy="counterpart-info"
      title={
        tabType === TAB_TYPE_SELLING
          ? i18n`dlv_orders_details_buyer`
          : i18n`dlv_orders_details_seller`
      }
    >
      <S.CounterPartInfo>
        {lines.map(
          info =>
            info && (
              <S.CounterPartInfoLine key={info.desc}>
                <S.InfoDesc>{i18n(`dlv_user_${info.desc}`)}</S.InfoDesc>
                <S.InfoVal data-testid={info.desc}>
                  {info.link ? (
                    <S.PhoneLink href={`tel:${info.val}`}>{info.val}</S.PhoneLink>
                  ) : (
                    info.val
                  )}
                </S.InfoVal>
              </S.CounterPartInfoLine>
            ),
        )}
      </S.CounterPartInfo>
    </DetailsCard>
  );
};

export default memo(CounterPartUserCard);
